import './Event.css'

const Event = ({onClick, image, date, title, location, description}) => {
    return (
        <div className='event-container'>
            <img className='event-image' src={image} alt='cool event image, too sad you cant see it!'></img>
            <div className='event-text-content'>
                <div>
                    <div className='event-title-date-container'>
                        <span className='event-title'>{title}</span>
                        <span className='event-date'>{date}</span>
                    </div>
                    <span className='event-location'>{location}</span>
                </div>
                <span className='event-description'>{description}</span>
                <span className='event-link' onClick={onClick}>Explore Event</span>
            </div>
        </div>
    )
}

export default Event
